import { HeaderAndTableCellDraft } from '@markant-platform/shared/table/model';

export const AUDIT_TABLE_HEADER_AND_CELLS: HeaderAndTableCellDraft[] = [
  {
    headerCellColumnId: 'modifiedAt',
    headerCellTranslationKey: 'audit.table.header.modifiedAt',
    tableCellContentKey: 'modifiedAt',
    tableCellContentType: 'DATE',
    tableCellDateFormat: 'full',
  },
  {
    headerCellColumnId: 'field',
    headerCellTranslationKey: 'audit.table.header.attribute',
    tableCellContentKey: 'label',
    tableCellContentType: 'STRING',
  },
  {
    headerCellColumnId: 'previousValue',
    headerCellTranslationKey: 'audit.table.header.previous',
    tableCellContentKey: 'previousValue',
    tableCellContentType: 'STRING',
  },
  {
    headerCellColumnId: 'currentValue',
    headerCellTranslationKey: 'audit.table.header.current',
    tableCellContentKey: 'currentValue',
    tableCellContentType: 'STRING',
  },
  {
    headerCellColumnId: 'modifiedBy',
    headerCellTranslationKey: 'audit.table.header.modifiedBy',
    tableCellContentKey: 'modifiedBy',
    tableCellContentType: 'STRING',
  },
  {
    headerCellColumnId: 'reason',
    headerCellTranslationKey: 'audit.table.header.reason',
    tableCellContentKey: 'reason',
    tableCellContentType: 'STRING',
  },
];
